import React from 'react';
import _ from 'lodash';

import {
  ApprovalTypeName,
  usePartner_ReturnAuthorizationLifeCycleWidgetQuery
} from 'generated/graphql';

import { Timeline } from 'modules';
import { DateTime } from 'luxon';



export interface IData {
  refundId: string;
  refundStatus: ApprovalTypeName;
  steps: Timeline.IStep[];
}


export function usePartnerQuery(returnAuthorizationId: string, queryAsCustomer: boolean) {
  const tuple = usePartner_ReturnAuthorizationLifeCycleWidgetQuery({
    variables: {
      returnAuthorizationId,
      queryAsCustomer
    }
  });

  return React.useMemo(
    () => {
      const lifeCycle = queryAsCustomer ?
        tuple.data?.returnAuthorizationLite?.lifeCycle :
        tuple.data?.returnAuthorization?.lifeCycle;

      const data: IData = {
        refundId: tuple.data?.returnAuthorization?.refund?.id ?? '',
        refundStatus: tuple.data?.returnAuthorization?.refund?.approvalType.name ?? 'pending',
        steps: _.map(lifeCycle ?? [], (step): Timeline.IStep => ({
          completedAt: step.completedOn ? DateTime.fromISO(step.completedOn) : null,
          approvalType: step.approvalType,
          label: step.label
        }))
      };

      return {
        ...tuple,
        data
      };
    },
    [
      queryAsCustomer,
      tuple
    ]
  );
}
